export function getTopicWord(clusterInformation, index) {
  if (index >= clusterInformation['words'].length) {
    return '';
  }

  let clusterWord = clusterInformation['words'][index];
  if (
    clusterInformation['override_words'] &&
    clusterInformation['override_words'][index]
  ) {
    clusterWord = clusterInformation['override_words'][index];
  }

  return clusterWord;
}

export function getTopicUrl(clusterInformation, index) {
  if (
    index >= clusterInformation['urls'].length &&
    index >= clusterInformation['override_urls'].length
  ) {
    return '';
  }

  let clusterUrl = clusterInformation['urls'][index];
  if (
    clusterInformation['override_urls'] &&
    clusterInformation['override_urls'][index]
  ) {
    clusterUrl = clusterInformation['override_urls'][index];
  }

  return clusterUrl;
}
